import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownAnnualIncome } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownAnnualIncome";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { processTypeEnum } from "../../Resource/Contents";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { calculateMaximumInitialIncomePayment } from "./Helper/IncomePaymentHelper";

interface IDifferentInitialIncomePaymentProps extends IProcessComponentProps {
    data: DrawdownAnnualIncome;
    labels: any;
    messages: any;
    drawdownType?: DrawdownType;
    pensionBase: PensionBase;
    processType?: processTypeEnum;
    isITFC: boolean;
    regularCrystalDifferentInital?: boolean;
}
interface IDifferentInitialIncomePaymentState {}

export class DifferentInitialIncomePayment extends ProcessComponent<
    IDifferentInitialIncomePaymentProps,
    IDifferentInitialIncomePaymentState
> {
    constructor(props: any) {
        super(props);
    }

    private handleChange(changes) {
        const { data, onChange } = this.props;
        const changedIncome = { ...data, ...changes };
        this.onDataChange(onChange, changedIncome, data);
    }

    public render(): JSX.Element {
        const {
            data,
            labels,
            messages,
            drawdownType,
            pensionBase,
            processType,
            isITFC,
            regularCrystalDifferentInital,
        } = this.props;

        return (
            <>
                {drawdownType != DrawdownType.Regular && (
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label={labels.takeDifferentInitialIncomePayment}
                        selected={data?.TakeDifferentInitialIncomePayment || regularCrystalDifferentInital || false}
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        tooltip={labels.takeDifferentInitialIncomePaymentTooltip}
                        onChange={(v) => {
                            if (v) {
                                this.handleChange({ TakeDifferentInitialIncomePayment: v });
                            } else {
                                this.handleChange({
                                    TakeDifferentInitialIncomePayment: v,
                                    GrossInitialIncomePayment: {
                                        Amount: 0,
                                        Currency: CurrencyCode.NotSpecified,
                                    },
                                });
                            }
                        }}
                    />
                )}
                {(data?.TakeDifferentInitialIncomePayment || regularCrystalDifferentInital) && (
                    <>
                        <div className="row">
                            <span className="col-6 h4">{labels.maximumInitialIncomePayment}</span>
                            <span className="col-6 pl-0" data-test="maximumInitialIncomePayment">
                                {MoneyDisplayHelper.FromatMoneyDisplay(
                                    calculateMaximumInitialIncomePayment(
                                        processType,
                                        pensionBase,
                                        isITFC,
                                    ),
                                    CurrencyCode.GBP
                                )}
                            </span>
                        </div>

                        <div className="row">
                            <div className="col-4">
                                <MoneyTextBoxEditor
                                    id="grossInitialIncomePayment"
                                    label={labels.grossInitialIncomePayment}
                                    value={
                                        data?.GrossInitialIncomePayment?.Amount ?? null
                                    }
                                    currency={data?.GrossInitialIncomePayment?.Currency || CurrencyCode.GBP}
                                    onChange={(v) =>
                                        this.handleChange({
                                            GrossInitialIncomePayment: {
                                                Amount: v,
                                                Currency: data?.GrossInitialIncomePayment?.Currency || CurrencyCode.GBP,
                                            },
                                        })
                                    }
                                    validationRules={[
                                        {
                                            errorMessage: "Please enter an amount that is greater than zero.",
                                            validator: (v) => {
                                            if (regularCrystalDifferentInital) {
                                                return v == null || v >= 0;
                                            }
                                                return v > 0;
                                          },
                                        }
                                    ]}
                                    required={messages.grossInitialIncomePaymentRequired}
                                    atMost={{
                                        errorMessage: messages.messagesGrossInitialIncomeOver,
                                        value: calculateMaximumInitialIncomePayment(
                                            processType,
                                            pensionBase,
                                            isITFC,
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default DifferentInitialIncomePayment;
